import {IApplicationState} from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const isAllowSorting = (
    state: IApplicationState,
): boolean => {
    return getAuthUser(state).allowPriorityAutoSorting;
};
